export default __webpack_public_path__ + "static/media/3D_Variant02.69e99ee4.png";